// extracted by mini-css-extract-plugin
export default {"button":"DeleteButton_button__xgF7A","icon":"DeleteButton_icon__B+823"};